import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import { TokenRefreshService } from '@app/authentication/services/token-refresh.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    // TokenRefreshService is injected here to ensure it is instantiated early
    // (its constructor starts the proactive refresh timer on login).
    constructor(
        private authenticationService: AuthenticationService,
        _tokenRefresh: TokenRefreshService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const user = this.authenticationService.userValue;
        const isLoggedIn = user && user.token;
        const isApiUrl = request.url.startsWith(environment.apiUrl);

        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${user.token}`,
                },
            });
        }

        return next.handle(request);
    }
}
